<section class="container privacy">
    <div class="headline">
        <h1 class="title">terms &amp; conditions</h1>
        <img src="../../../assets/terms/TermsConditions.png" alt="terms &amp; conditions" class="icons">
    </div>

    <div class="content">

        <p class="subtitle">1. ACCEPTANCE OF TERMS</p>
        <p>The WorldERP, Inc. welcomes you! <br>{{SiteName}} provides its service to you subject
            to the following Terms of Service ("TOS"), which may be updated by us from time to time without
            notice to you. In addition, when using particular {{SiteName}} owned or operated websites ("Sites") and
            services, you and {{SiteName}} shall be subject to any posted guidelines or rules applicable to such
            services, which may be posted from time to time. All such guidelines or rules are hereby
            incorporated by reference into the TOS.<br>{{SiteName}} may also offer other services that are governed
            by different Terms of Service.</p>

        <p class="subtitle">2. DESCRIPTION OF SERVICE</p>
        <p>{{SiteName}} provides users with access to a rich collection of resources, including various shopping 
            services and communication tools, search services, personalized content and branded programming
            through its network of properties which may be accessed through any various medium or device now
            known or hereafter developed (the "Service"). You also understand and agree that the Service may
            include advertisements from participating vendors and that these advertisements are necessary for
            {{SiteName}} to provide the Service. You also understand and agree that the Service may include certain
            communications from {{SiteName}}, such as service announcements, administrative messages and the {{SiteName}}
            Newsletter, and that these communications are considered part of {{SiteName}} registration and you will
            not be able to opt out of receiving them. Unless explicitly stated otherwise, any new features that
            augment or enhance the current Service, including the release of new {{SiteName}} properties, shall be
            subject to the TOS. You understand and agree that the Service is provided "AS-IS" and that {{SiteName}}
            assumes no responsibility for the timeliness, deletion, mis-delivery or failure to store any user
            communications or personalization settings. You are responsible for obtaining access to the Service,
            and that access may involve third-party fees (such as Internet service provider or airtime charges).
            You are responsible for those fees, including those fees associated with the display or delivery of
            advertisements. In addition, you must provide and are responsible for all equipment necessary to
            access the Service.</p>

        <p class="subtitle">3. YOUR REGISTRATION OBLIGATIONS</p>
        <p>In consideration of your use of the Service, you represent that you are of legal age to form a
            binding contract and are not a person barred from receiving services under the laws of the United
            States or other applicable jurisdiction. You also agree to: (a) provide true, accurate, current and
            complete information about yourself as prompted by the Service's registration form (the
            "Registration Data") and (b) maintain and promptly update the Registration Data to keep it true,
            accurate, current and complete. If you provide any information that is untrue, inaccurate, not
            current or incomplete, or {{SiteName}} has reasonable grounds to suspect that such information is untrue,
            inaccurate, not current or incomplete, {{SiteName}} has the right to suspend or terminate your account
            and refuse any and all current or future use of the Service (or any portion thereof). {{SiteName}} is
            concerned about the safety and privacy of all its users.</p>

        <p class="subtitle">4. {{SiteName}} PRIVACY POLICY</p>
        <p>Registration Data and certain other information about you is subject to our Privacy Policy. For more
            information, see our full privacy policy. You understand that through your use of the Service you
            consent to the collection and use (as set forth in the Privacy Policy) of this information,
            including the transfer of this information to the United States and/or other countries for storage,
            processing and use by {{SiteName}} and its affiliates.</p>

        <p class="subtitle">5. MEMBER ACCOUNT, PASSWORD AND SECURITY</p>
        <p>You will receive a password and account designation upon completing the Service's registration
            process. You are responsible for maintaining the confidentiality of the password and account and are
            fully responsible for all activities that occur under your password or account. You agree to (a)
            immediately notify {{SiteName}} of any unauthorized use of your password or account or any other breach
            of security, and (b) ensure that you exit from your account at the end of each session. {{SiteName}}
            cannot and will not be liable for any loss or damage arising from your failure to comply with this
            Section 5.</p>

        <p class="subtitle">6. MEMBER CONDUCT</p>
        <p>You understand that all information, data, text, software, music, sound, photographs, graphics,
            video, messages, tags, or other materials ("Content"), whether publicly posted or privately
            transmitted, are the sole responsibility of the person from whom such Content originated. This means
            that you, and not {{SiteName}}, are entirely responsible for all Content that you upload, post, email,
            transmit or otherwise make available via the Service. {{SiteName}} does not control the Content posted
            via the Service and, as such, does not guarantee the accuracy, integrity or quality of such Content.
            You understand that by using the Service, you may be exposed to Content that is offensive, indecent
            or objectionable. Under no circumstances will {{SiteName}} be liable in any way for any Content,
            including, but not limited to, any errors or omissions in any Content, or any loss or damage of any
            kind incurred as a result of the use of any Content posted, emailed, transmitted or otherwise made
            available via the Service.</p>

        <p class="subtitle">You agree to not use the Service to:</p>
        <p>upload, post, transmit or otherwise make available any Content that is unlawful, harmful,
            threatening, abusive, harassing, tortuous, defamatory, vulgar, obscene, libelous, invasive of
            another's privacy, hateful, or racially, ethnically or otherwise objectionable; impersonate any
            person or entity, including, but not limited to, a {{SiteName}} official, forum leader, guide or host, or
            falsely state or otherwise misrepresent your affiliation with a person or entity; forge headers or
            otherwise manipulate identifiers in order to disguise the origin of any Content transmitted through
            the Service; upload, post, transmit or otherwise make available any Content that you do not have a
            right to make available under any law or under contractual or fiduciary relationships (such as
            inside information, proprietary and confidential information learned or disclosed as part of
            employment relationships or under nondisclosure agreements); upload, post, transmit or otherwise
            make available any Content that infringes any patent, trademark, trade secret, copyright or other
            proprietary rights ("Rights") of any party; upload, post, transmit or otherwise make available any
            material that contains software viruses or any other computer code, files or programs designed to
            interrupt, destroy or limit the functionality of any computer software or hardware or
            telecommunications equipment; disrupt the normal flow of dialogue, cause a screen to "scroll" faster
            than other users of the Service are able to type, or otherwise act in a manner that negatively
            affects other users' ability to engage in real time exchanges; interfere with or disrupt the Service
            or servers or networks connected to the Service, or disobey any requirements, procedures, policies
            or regulations of networks connected to the Service; intentionally or unintentionally violate any
            applicable local, state, national or international law, including, but not limited to, regulations
            promulgated by the U.S. Securities and Exchange Commission, any rules of any national or other
            securities exchange, including, without limitation, the New York Stock Exchange, the American Stock
            Exchange or the NASDAQ, and any regulations having the force of law; provide material support or
            resources (or to conceal or disguise the nature, location, source, or ownership of material support
            or resources) to any organization(s) designated by the United States government as a foreign
            terrorist organization pursuant to section 219 of the Immigration and Nationality Act; "stalk" or
            otherwise harass another; and/or collect or store personal data about other users in connection with
            the prohibited conduct and activities set forth in paragraphs a through m above.<br>You acknowledge
            that {{SiteName}} may or may not pre-screen Content, but that {{SiteName}} and its designees
            shall have the right (but not the obligation) in their sole discretion to pre-screen, refuse, or
            move any Content that is available via the Service. Without limiting the foregoing, {{SiteName}} and its
            designees shall have the right to remove any Content that violates the TOS or is otherwise
            objectionable. You agree that you must evaluate, and bear all risks associated with, the use of any
            Content, including any reliance on the accuracy, completeness, or usefulness of such Content. In
            this regard, you acknowledge that you may not rely on any Content created by {{SiteName}} or submitted to
            {{SiteName}}, including without limitation information in {{SiteName}} Message Boards and in all other parts
            of the Service.<br>You acknowledge, consent and agree that {{SiteName}} may access, preserve and disclose
            your account
            information and Content if required to do so by law or in a good faith belief that such access
            preservation or disclosure is reasonably necessary to: (a) comply with legal process; (b) enforce
            the TOS; (c) respond to claims that any Content violates the rights of third parties; (d) respond to
            your requests for customer service; or (e) protect the rights, property or personal safety of
            {{SiteName}}, its users and the public.<br>You understand that the technical processing and transmission
            of the Service, including your
            Content, may involve (a) transmissions over various networks; and (b) changes to conform and adapt
            to technical requirements of connecting networks or devices.<br>You understand that the Service and
            software embodied within the Service may include security
            components that permit digital materials to be protected, and that use of these materials is subject
            to usage rules set by {{SiteName}} and/or content providers who provide content to the Service.<br>You
            may not attempt to override or circumvent any of the usage rules embedded into the Service. Any
            unauthorized reproduction, publication, further distribution or public exhibition of the materials
            provided on the Service, in whole or in part, is strictly prohibited.</p>

        <p class="subtitle">7. INTERSTATE NATURE OF COMMUNICATIONS ON {{SiteName}} NETWORK</p>
        <p>When you register with {{SiteName}}, you acknowledge that in using {{SiteName}} services to send electronic
            communications (including but not limited to notifications, search queries, sending messages,
            uploading photos and files to {{SiteName}} Photos or Briefcase, and other Internet activities), you will
            be causing communications to be sent through WorldERP's™ computer networks, portions of which are
            located in California, Texas, Virginia, and other locations in the United States and portions of
            which are located abroad. As a result, and also as a result of WorldERP’s™ network architecture and
            business practices and the nature of electronic communications, even communications that seem to be
            intrastate in nature can result in the transmission of interstate communications regardless of where
            you are physically located at the time of transmission. Accordingly, by agreeing to this Terms of
            Service, you acknowledge that use of the service results in interstate data transmissions.</p>

        <p class="subtitle">8. SPECIAL ADMONITIONS FOR INTERNATIONAL USE</p>
        <p>Recognizing the global nature of the Internet, you agree to comply with all local rules regarding
            online conduct and acceptable Content. Specifically, you agree to comply with all applicable laws
            regarding the transmission of technical data exported from the United States or the country in which
            you reside.</p>

        <p class="subtitle">9. CONTENT SUBMITTED OR MADE AVAILABLE FOR INCLUSION ON THE SERVICE</p>
        <p>{{SiteName}} does not claim ownership of Content you submit or make available for inclusion on the
            Service. However, with respect to Content you submit or make available for inclusion on publicly
            accessible areas of the Service, you grant {{SiteName}} the following worldwide, royalty-free and
            non-exclusive license(s), as applicable:<br>With respect to Content you submit or make available
            for inclusion on publicly accessible areas of {{SiteName}} Groups, the license to use, distribute,
            reproduce, modify, adapt, publicly perform and
            publicly display such Content on the Service solely for the purposes of providing and promoting
            the specific {{SiteName}} Group to which such Content was submitted or made available. This license
            exists
            only for as long as you elect to continue to include such Content on the Service and will
            terminate
            at the time you remove or {{SiteName}} removes such Content from the Service.<br>With respect to
            photos,
            graphics, audio or video you submit or make available for inclusion on
            publicly accessible areas of the Service other than {{SiteName}} Groups, the license to use,
            distribute,
            reproduce, modify, adapt, publicly perform and publicly display such Content on the Service
            solely
            for the purpose for which such Content was submitted or made available. This license exists only
            for
            as long as you elect to continue to include such Content on the Service and will terminate at
            the
            time you remove or {{SiteName}} removes such Content from the Service.<br>With respect to Content
            other
            than photos, graphics, audio or video you submit or make available for
            inclusion on publicly accessible areas of the Service other than {{SiteName}} Groups, the perpetual,
            irrevocable and fully sublicensable license to use, distribute, reproduce, modify, adapt,
            publish,
            translate, publicly perform and publicly display such Content (in whole or in part) and to
            incorporate such Content into other works in any format or medium now known or later developed.
            "Publicly accessible" areas of the Service are those areas of the {{SiteName}} network of properties
            that
            are intended by {{SiteName}} to be available to the licensed entity. By way of example, publicly
            accessible areas of the Service would include {{SiteName}} Vendor shopping, Approval Journals and
            portions of {{SiteName}} Account Maintenance.</p>

        <p class="subtitle">10. INDEMNITY</p>
        <p>You agree to indemnify and hold {{SiteName}} and its subsidiaries, affiliates, officers, agents,
            employees, partners and licensors harmless from any claim or demand, including reasonable
            attorneys'
            fees, made by any third party due to or arising out of Content you submit, post, transmit or
            otherwise make available through the Service, your use of the Service, your connection to the
            Service, your violation of the TOS, or your violation of any rights of another.</p>

        <p class="subtitle">11. NO RESALE OF SERVICE</p>
        <p>You agree not to reproduce, duplicate, copy, sell, trade, resell or exploit for any commercial
            purposes, any portion of the Service (including your {{SiteName}} ID), use of the Service, or access
            to
            the Service.</p>

        <p class="subtitle">12. GENERAL PRACTICES REGARDING USE AND STORAGE</p>
        <p>You acknowledge that {{SiteName}} may establish general practices and limits concerning use of the
            Service, including without limitation the maximum number of days that communication journals,
            postings or other uploaded Content will be retained by the Service, the maximum number of
            submissions that may be sent from or received by an account on the Service, the maximum size of
            any
            transaction that may be sent from or received by an account on the Service, the maximum disk
            space
            that will be allotted on {{SiteName}}'s servers on your behalf, and the maximum number of times (and
            the
            maximum duration for which) you may access the Service in a given period of time. You agree that
            {{SiteName}} has no responsibility or liability for the deletion or failure to store any messages and
            other communications or other Content maintained or transmitted by the Service. You acknowledge
            that
            {{SiteName}} reserves the right to log off accounts that are inactive for an extended period of time.
            You
            further acknowledge that {{SiteName}} reserves the right to modify these general practices and limits
            from time to time.</p>

        <p class="subtitle">13. MODIFICATIONS TO SERVICE</p>
        <p>{{SiteName}} reserves the right at any time and from time to time to modify or discontinue,
            temporarily
            or
            permanently, the Service (or any part thereof) with or without notice. You agree that {{SiteName}}
            shall
            not be liable to you or to any third party for any modification, suspension or discontinuance of
            the
            Service.</p>

        <p class="subtitle">14. TERMINATION</p>
        <p>You agree that {{SiteName}} may, under certain circumstances and without prior notice, immediately
            terminate your {{SiteName}} account, any associated email address, and access to the Service. Cause
            for
            such termination shall include, but not be limited to, (a) breaches or violations of the TOS or
            other incorporated agreements or guidelines, (b) requests by law enforcement or other government
            agencies, (c) a request by you (self-initiated account deletions), (d) discontinuance or
            material
            modification to the Service (or any part thereof), (e) unexpected technical or security issues
            or
            problems, (f) extended periods of inactivity, (g) engagement by you in fraudulent or illegal
            activities, and/or (h) nonpayment of any fees owed by you in connection with the Services.
            Termination of your {{SiteName}} account includes (a) removal of access to all offerings within the
            Service, (b) deletion of your password and all related information, files and content associated
            with or inside your account (or any part thereof), and (c) barring of further use of the
            Service.
            Further, you agree that all terminations for cause shall be made in {{SiteName}}'s sole discretion
            and
            that {{SiteName}} shall not be liable to you or any third party for any termination of your account,
            any
            associated email address, or access to the Service.</p>

        <p class="subtitle">15. DEALINGS WITH ADVERTISERS</p>
        <p>Your correspondence or business dealings with, or participation in promotions of, advertisers
            found
            on or through the Service, including payment and delivery of related goods or services, and any
            other terms, conditions, warranties or representations associated with such dealings, are solely
            between you and such advertiser. You agree that {{SiteName}} shall not be responsible or liable for
            any
            loss or damage of any sort incurred as the result of any such dealings or as the result of the
            presence of such advertisers on the Service.</p>

        <p class="subtitle">16. LINKS</p>
        <p>The Service may provide, or third parties may provide, links to other World Wide Web sites or
            resources. Because {{SiteName}} has no control over such sites and resources, you acknowledge and
            agree
            that {{SiteName}} is not responsible for the availability of such external sites or resources, and
            does
            not endorse and is not responsible or liable for any Content, advertising, products or other
            materials on or available from such sites or resources. You further acknowledge and agree that
            {{SiteName}} shall not be responsible or liable, directly or indirectly, for any damage or loss
            caused or
            alleged to be caused by or in connection with use of or reliance on any such Content, goods or
            services available on or through any such site or resource.</p>

        <p class="subtitle">17. {{SiteName}}'S PROPRIETARY RIGHTS</p>
        <p>You acknowledge and agree that the Service and any necessary software used in connection with
            the
            Service ("Software") contain proprietary and confidential information that is protected by
            applicable intellectual property and other laws. You further acknowledge and agree that Content
            contained in sponsor advertisements or information presented to you through the Service or by
            advertisers is protected by copyrights, trademarks, service marks, patents or other proprietary
            rights and laws. Except as expressly authorized by {{SiteName}} or advertisers, you agree not to
            modify,
            rent, lease, loan, sell, distribute or create derivative works based on the Service or the
            Software,
            in whole or in part.<br>{{SiteName}} grants you a personal, non-transferable and non-exclusive right
            and
            license to use the object code of its Software on a single computer; provided that you do not
            (and
            do not allow any third party to) copy, modify, create a derivative work from, reverse engineer,
            reverse assemble or otherwise attempt to discover any source code, sell, assign, sublicense,
            grant a
            security interest in or otherwise transfer any right in the Software. You agree not to modify
            the
            Software in any manner or form, nor to use modified versions of the Software, including (without
            limitation) for the purpose of obtaining unauthorized access to the Service. You agree not to
            access
            the Service by any means other than through the interface that is provided by {{SiteName}} for use in
            accessing the Service.</p>

        <p class="subtitle">18. DISCLAIMER OF WARRANTIES</p>
        <p>YOU EXPRESSLY UNDERSTAND AND AGREE THAT:<br>YOUR USE OF THE SERVICE
            IS AT YOUR SOLE RISK. THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS
            AVAILABLE" BASIS. {{SiteName}} AND ITS SUBSIDIARIES, AFFILIATES, OFFICERS, EMPLOYEES, AGENTS,
            PARTNERS
            AND LICENSORS EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
            INCLUDING,
            BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE
            AND
            NON-INFRINGEMENT. {{SiteName}} AND ITS SUBSIDIARIES, AFFILIATES, OFFICERS, EMPLOYEES, AGENTS,
            PARTNERS
            AND LICENSORS MAKE NO WARRANTY THAT THE SERVICE WILL MEET YOUR REQUIREMENTS; (ii) THE SERVICE
            WILL
            BE UNINTERRUPTED, TIMELY, SECURE OR ERROR-FREE; (iii) THE RESULTS THAT MAY BE OBTAINED FROM THE
            USE
            OF THE SERVICE WILL BE ACCURATE OR RELIABLE; (iv) THE QUALITY OF ANY PRODUCTS, SERVICES,
            INFORMATION
            OR OTHER MATERIAL PURCHASED OR OBTAINED BY YOU THROUGH THE SERVICE WILL MEET YOUR EXPECTATIONS;
            AND
            (v) ANY ERRORS IN THE SOFTWARE WILL BE CORRECTED. ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED
            THROUGH THE USE OF THE SERVICE IS ACCESSED AT YOUR OWN DISCRETION AND RISK, AND YOU WILL BE
            SOLELY
            RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE
            DOWNLOAD OF
            ANY SUCH MATERIAL. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM
            {{SiteName}}
            OR THROUGH OR FROM THE SERVICE SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THE TOS. A
            SMALL
            PERCENTAGE OF USERS MAY EXPERIENCE EPILEPTIC SEIZURES WHEN EXPOSED TO CERTAIN LIGHT PATTERNS OR
            BACKGROUNDS ON A COMPUTER SCREEN OR WHILE USING THE SERVICE. CERTAIN CONDITIONS MAY INDUCE
            PREVIOUSLY UNDETECTED EPILEPTIC SYMPTOMS EVEN IN USERS WHO HAVE NO HISTORY OF PRIOR SEIZURES OR
            EPILEPSY. IF YOU, OR ANYONE IN YOUR FAMILY, HAVE AN EPILEPTIC CONDITION, CONSULT YOUR PHYSICIAN
            PRIOR TO USING THE SERVICE. IMMEDIATELY DISCONTINUE USE OF THE SERVICE AND CONSULT YOUR
            PHYSICIAN IF
            YOU EXPERIENCE ANY OF THE FOLLOWING SYMPTOMS WHILE USING THE SERVICE: DIZZINESS, ALTERED VISION,
            EYE
            OR MUSCLE TWITCHES, LOSS OF AWARENESS, DISORIENTATION, ANY INVOLUNTARY MOVEMENT, OR CONVULSIONS.
        </p>

        <p class="subtitle">19. LIMITATION OF LIABILITY</p>
        <p>YOU EXPRESSLY UNDERSTAND AND AGREE THAT {{SiteName}} AND ITS SUBSIDIARIES, AFFILIATES, OFFICERS,
            EMPLOYEES, AGENTS, PARTNERS AND LICENSORS SHALL NOT BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT,
            INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, INCLUDING, BUT NOT LIMITED TO, DAMAGES
            FOR
            LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES (EVEN IF {{SiteName}} HAS BEEN
            ADVISED OF
            THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM: THE USE OR THE INABILITY TO USE THE SERVICE;
            (ii)
            THE COST OF PROCUREMENT OF SUBSTITUTE GOODS AND SERVICES RESULTING FROM ANY GOODS, DATA,
            INFORMATION
            OR SERVICES PURCHASED OR OBTAINED OR MESSAGES RECEIVED OR TRANSACTIONS ENTERED INTO THROUGH OR
            FROM
            THE SERVICE; (iii) UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; (iv)
            STATEMENTS OR CONDUCT OF ANY THIRD PARTY ON THE SERVICE; OR (v) ANY OTHER MATTER RELATING TO THE
            SERVICE.</p>

        <p class="subtitle">20. EXCLUSIONS AND LIMITATIONS</p>
        <p>SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR
            EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME OF THE ABOVE
            LIMITATIONS OF
            SECTIONS 17 AND 18 MAY NOT APPLY TO YOU.</p>

        <p class="subtitle">21. SPECIAL ADMONITION FOR SERVICES RELATING TO FINANCIAL MATTERS</p>
        <p>If you intend to create or join any service, receive or request any news, messages, alerts or
            other
            information from the Service concerning companies, stock quotes, investments or securities,
            please
            read the above Sections 18 and 19 again. They go doubly for you. In addition, for this type of
            information particularly, the phrase "Let the investor beware" is apt. The Service is provided
            for
            informational purposes only, and no Content included in the Service is intended for trading or
            investing purposes. {{SiteName}} and its licensors shall not be responsible or liable for the
            accuracy,
            usefulness or availability of any information transmitted or made available via the Service, and
            shall not be responsible or liable for any trading or investment decisions based on such
            information.</p>

        <p class="subtitle">22. NO THIRD-PARTY BENEFICIARIES</p>
        <p>You agree that, except as otherwise expressly provided in this TOS, there shall be no
            third-party
            beneficiaries to this agreement.</p>

        <p class="subtitle">23. NOTICE</p>
        <p>{{SiteName}} may provide you with notices, including those regarding changes to the TOS, by email,
            regular
            mail or postings on the Service.</p>

        <p class="subtitle">24. TRADEMARK INFORMATION</p>
        <p>The {{SiteName}}, {{SiteName}}logo and {{SiteName}} (in any other language characters) trademarks and service
            marks
            and other {{SiteName}} logos and product and service names are trademarks of WorldERP Inc. (the
            "{{SiteName}}
            Marks"). Without {{SiteName}}'s™ prior permission, you agree not to display or use in any manner the
            {{SiteName}} Marks.</p>

        <p class="subtitle">25. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT OR INTELLECTUAL PROPERTY
            INFRINGEMENT</p>
        <p>{{SiteName}} respects the intellectual property of others, and we ask our users to do the same.
            {{SiteName}}
            may, in appropriate circumstances and at its discretion, disable and/or terminate the accounts
            of
            users who may be repeat infringers. If you believe that your work has been copied in a way that
            constitutes copyright infringement, or your intellectual property rights have been otherwise
            violated, please provide {{SiteName}}'s Copyright Agent the following information: an electronic or
            physical signature of the person authorized to act on behalf of the owner of the copyright or
            other
            intellectual property interest; a description of the copyrighted work or other intellectual
            property
            that you claim has been infringed; a description of where the material that you claim is
            infringing
            is located on the site; your address, telephone number, and email address; a statement by you
            that
            you have a good faith belief that the disputed use is not authorized by the copyright owner, its
            agent, or the law; a statement by you, made under penalty of perjury, that the above information
            in
            your Notice is accurate and that you are the copyright or intellectual property owner or
            authorized
            to act on the copyright or intellectual property owner's behalf.<br>
            {{SiteName}}'s Agent for Notice of claims of copyright or other intellectual property infringement
            can be
            reached as follows:<br>
            <br>
            <b>By mail:<br>
                Copyright Agent<br>
                c/o WorldERP, Inc<br>
                1621 Central Ave.<br>
                Cheyenne, WY 82001<br>
                <br>
                Or by email: <span class="link email">moc.predlrow@lagel</span></b>
            <br>
        </p>

        <p class="subtitle">26. GENERAL INFORMATION</p>
        <p>Entire Agreement. The TOS constitutes the entire agreement between you and {{SiteName}} and governs
            your use of the Service, superseding any prior agreements between you and {{SiteName}} with respect
            to the Service. You also may be subject to additional terms and conditions that may apply when
            you use or purchase certain other {{SiteName}} services, affiliate services, third-party content or
            third-party software.<br>Choice of Law and Forum. The TOS and the relationship between you and
            {{SiteName}} shall be governed
            by the laws of the State of Nevada without regard to its conflict of law provisions. You and
            {{SiteName}} agree to submit to the personal and exclusive jurisdiction of the courts located within
            the county of Clark, Nevada.<br>Waiver and Severability of Terms. The failure of {{SiteName}} to
            exercise or enforce any right or
            provision of the TOS shall not constitute a waiver of such right or provision. If any provision
            of the TOS is found by a court of competent jurisdiction to be invalid, the parties nevertheless
            agree that the court should endeavor to give effect to the parties' intentions as reflected in
            the provision, and the other provisions of the TOS remain in full force and effect.
            No Right of Survivorship and Non-Transferability. You agree that your {{SiteName}} account is
            non-transferable and any rights to your {{SiteName}} ID or contents within your account terminate
            upon your death. Upon receipt of a copy of a death certificate, your account may be terminated
            and all contents therein permanently deleted.<br>Statute of Limitations. You agree that
            regardless of any statute or law to the contrary, any
            claim or cause of action arising out of or related to use of the Service or the TOS must be
            filed within one (1) year after such claim or cause of action arose or be forever barred.
            The section titles in the TOS are for convenience only and have no legal or contractual effect.
        </p>

        <p class="subtitle">27. VIOLATIONS</p>
        <p>Please report any violations of the TOS to our Customer Care group. By mail: Customer Care By
            mail:</p>
        <p><b>Customer Care<br>
            c/o WorldERP, Inc<br>
            1621 Central Ave.<br>
            Cheyenne, WY 82001<br>
            <br>Or by email: <span class="link email">moc.predlrow@lagel</span></b>
        </p>
    </div>
</section>
